/** Display groups leave each task's saved manual position intact. */
export function executionGroup(item, isDone) {
  return (item.routine ? item.done : isDone(item.nodeId)) ? 'completed' : item.postponedUntil ? 'postponed' : 'current';
}

export function groupExecutionItems(items, isDone) {
  const groups = { current: [], postponed: [], completed: [] };
  for (const item of items) groups[executionGroup(item, isDone)].push(item);
  return [...groups.current, ...groups.postponed, ...groups.completed];
}

export const executionItemId = item => item.executionId || item.nodeId;

/** Reorder against the latest entries, preserving new arrivals and other groups. */
export function moveExecutionItem(items, nodeId, targetId, after, isDone) {
  const ordered = groupExecutionItems(items, isDone).map(executionItemId);
  const source = items.find(item => executionItemId(item) === nodeId);
  const target = items.find(item => executionItemId(item) === targetId);
  if (nodeId === targetId || !source || !target
      || executionGroup(source, isDone) !== executionGroup(target, isDone)) return null;
  const next = ordered.filter(id => id !== nodeId);
  next.splice(next.indexOf(targetId) + (after ? 1 : 0), 0, nodeId);
  return next.some((id, i) => id !== ordered[i]) ? next : null;
}

/**
 * The day a note's task list counts for: the local date the note was created
 * (a note is a period). Ticking "worked on it" in any note records this day,
 * not the moment of the click, so a note can be completed later.
 * @param {{created?: string|number}} note
 * @returns {string|null} "YYYY-MM-DD", or null without a valid creation time
 */
export function noteDay(note) {
  const d = new Date(note?.created);
  if (!note?.created || Number.isNaN(d.getTime())) return null;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
